(function () {
  function initCollectionInfiniteScroll() {
    var sentinel = document.querySelector('.collection-infinite-scroll-sentinel');
    if (!sentinel) return;

    var grid = document.getElementById('product-grid');
    if (!grid) return;

    var nextUrl = sentinel.dataset.nextUrl;
    var sectionId = sentinel.dataset.sectionId || grid.dataset.id;
    var loading = false;
    var observer;

    function appendPage(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newGrid = doc.getElementById('product-grid');
      if (!newGrid) return null;

      newGrid.querySelectorAll(':scope > li, :scope > .add_full_width').forEach(function (node) {
        grid.appendChild(node);
      });

      var newSentinel = doc.querySelector('.collection-infinite-scroll-sentinel');
      return newSentinel ? newSentinel.dataset.nextUrl : null;
    }

    function setLoading(isLoading) {
      loading = isLoading;
      sentinel.classList.toggle('is-loading', isLoading);
      sentinel.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }

    function loadMore() {
      if (loading || !nextUrl) return;

      setLoading(true);

      var url = new URL(nextUrl, window.location.origin);
      url.searchParams.set('section_id', sectionId);

      fetch(url.toString())
        .then(function (response) {
          if (!response.ok) throw new Error('Failed to load collection page');
          return response.text();
        })
        .then(function (html) {
          nextUrl = appendPage(html);
          sentinel.dataset.nextUrl = nextUrl || '';

          if (!nextUrl) {
            if (observer) observer.disconnect();
            sentinel.remove();
          }
        })
        .catch(function () {
          if (observer) observer.disconnect();
        })
        .finally(function () {
          setLoading(false);
        });
    }

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadMore();
        });
      },
      { rootMargin: '400px 0px' }
    );

    observer.observe(sentinel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionInfiniteScroll);
  } else {
    initCollectionInfiniteScroll();
  }
})();
